import * as yup from "yup"

const salutationRequired = () =>
    yup.mixed().test(
        'my test',
        'Selecteer een aanhef',
        (text) => {
            if (text === null) {
                return false
            } else {
                return true
            }
        }
    )

export default salutationRequired